<template>
    <div>
        <div class="text-right bg-white pr-4 pt-2"><router-link to="/login"><i class="fa fa-sign-in pr-2"></i>Iniciar sesión</router-link></div>
        <div class="app flex-row align-items-center bg-white">

            <div class="container">
                <b-row class="justify-content-center">
                    <b-col md="12">
                        <b-card-group>

                            <b-card no-body class="text-white" style="border: none;">
                                <b-card-body class="text-center">
                                    <div>
                                        <img src="img/logo.png" class="col-md-12">
                                    </div>
                                </b-card-body>
                            </b-card>

                            <b-card no-body md="12" style="border: none;">
                                <b-card-body class="p-4">
                                    <b-form @submit.prevent="forget">
                                        <h4 class="mb-3 text-center">Contraseña caducada</h4>

                                        <div class="alert alert-warning mx-5" role="alert">
                                            Su contraseña ha caducado y debe ressetearla por seguridad. Por favor, introduzca su email.
                                        </div>

                                        <b-input-group class="px-5 pb-3">
                                            <b-form-input type="email" class="form-control" placeholder="Introduzca su email" autocomplete="username email" v-model="user.email"/>
                                        </b-input-group>

                                        <b-row class="justify-content-center pt-2">
                                            <loading v-show="isLoading"/>
                                            <b-button v-show="!isLoading" type="submit" variant="primary" class="px-5 btn btn-pill" :disabled="!user.email">Resetear</b-button>
                                        </b-row>
                                    </b-form>
                                </b-card-body>
                            </b-card>

                        </b-card-group>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>

</template>

<script>

    export default {
        name: 'UpdatePassword',
        data: ()=> ({
            user:{
                email: "",
            },
            isLoading: false
        }),

        methods:{
            forget(){
                this.isLoading = true;
                axios.post('/login/reset', this.user)
                    .then(() => {
                        this.isLoading = false;
                        this.$_notificationMixin_success('Solicitud correcta', 'Pronto recibirá un correo con instrucciones');
                        this.$router.push({name: 'login'});
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        this.$_notificationMixin_success('Solicitud denegada', 'El correo facilitado es incorrecto');
                        console.log(error);
                    });
            }

        },
    }
</script>
<style scoped>
    input {
        border: 0;
        outline: 0;
        background: transparent;
        border-bottom: 1px solid lightgrey;
    }
</style>
